import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import {
  MapPin, MessageCircle, Video, Map, Shield, Image,
  Download, Menu, X, Check, Lock,
  Smartphone, Globe, Mail, Phone
} from "lucide-react";

const APK_URL = "https://customer-assets.emergentagent.com/job_bump-app-site/artifacts/jumago7k_application-4010c8d6-889c-4818-940f-f17b6286d632.apk";
const LOGO_CIRCLE = "https://customer-assets.emergentagent.com/job_bump-app-site/artifacts/cylwwas9_Logo%20t.png";
const LOGO_TEXT = "https://customer-assets.emergentagent.com/job_bump-app-site/artifacts/g91mm2s9_b%20logo%20name.png";

const SOCIALS = [
  { name: "LinkedIn", url: "https://www.linkedin.com/company/buumped", icon: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
  )},
  { name: "X", url: "https://x.com/buumped", icon: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4l11.733 16h4.267l-11.733 -16z"/><path d="M4 20l6.768 -6.768m2.46 -2.46l6.772 -6.772"/></svg>
  )},
  { name: "Threads", url: "https://www.threads.com/@buumped", icon: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.59 12c.025 3.086.718 5.496 2.057 7.164 1.432 1.783 3.631 2.698 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.14 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.96-.065-1.187.408-2.26 1.33-3.02.88-.724 2.105-1.133 3.546-1.182 1.048-.036 2.009.066 2.878.283-.052-.95-.358-1.668-.912-2.135-.633-.532-1.588-.803-2.838-.803h-.034c-.96.007-1.755.26-2.365.754l-1.31-1.55c.96-.775 2.2-1.19 3.684-1.204h.05c1.725 0 3.088.498 4.05 1.48.906.927 1.392 2.222 1.445 3.848.622.31 1.17.695 1.636 1.157 1.1 1.09 1.686 2.554 1.742 4.352h-.004c-.03.676-.166 1.948-.957 3.222-.828 1.333-2.304 2.924-5.066 3.482-1.02.206-2.13.305-3.266.305zm-.07-8.85c-.94.03-1.681.248-2.14.627-.42.348-.62.794-.59 1.323.045.765.63 1.635 2.244 1.635h.228c1.09-.06 1.895-.453 2.394-1.17.36-.516.595-1.174.697-1.97-.812-.212-1.73-.34-2.72-.355l-.112-.09z"/></svg>
  )},
  { name: "Instagram", url: "https://www.instagram.com/buumped/", icon: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="20" x="2" y="2" rx="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/></svg>
  )},
  { name: "TikTok", url: "https://www.tiktok.com/buumped", icon: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5"/></svg>
  )},
  { name: "YouTube", url: "https://www.youtube.com/@buumped", icon: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
  )},
  { name: "Facebook", url: "https://www.facebook.com/buumped", icon: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
  )},
];

/* ─── Fade in on scroll ─── */
function useInView(threshold = 0.15) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setVisible(true); obs.unobserve(el); } },
      { threshold }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, visible];
}

const FadeIn = ({ children, delay = 0, className = "" }) => {
  const [ref, visible] = useInView();
  return (
    <div
      ref={ref}
      className={className}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(24px)",
        transition: `opacity 0.6s ease ${delay}s, transform 0.6s ease ${delay}s`,
      }}
    >
      {children}
    </div>
  );
};

/* ─── Cookie Consent ─── */
const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("buumped_cookie_consent");
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("buumped_cookie_consent", "accepted");
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem("buumped_cookie_consent", "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg p-4 sm:p-6"
      style={{ animation: "slideUp 0.3s ease" }}
    >
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex-1">
          <p className="text-sm text-gray-700">
            We use cookies to improve your experience on our site. By continuing to browse, you agree to our{" "}
            <Link to="/cookies" className="text-[#F07167] underline" data-testid="cookie-policy-link">Cookie Policy</Link>.
          </p>
        </div>
        <div className="flex gap-3 shrink-0">
          <button
            data-testid="cookie-decline-btn"
            onClick={decline}
            className="px-5 py-2 text-sm text-gray-600 border border-gray-200 rounded-full hover:bg-gray-50 transition-colors"
          >
            Decline
          </button>
          <button
            data-testid="cookie-accept-btn"
            onClick={accept}
            className="px-5 py-2 text-sm text-white bg-[#F07167] rounded-full hover:bg-[#E85D52] transition-colors font-medium"
          >
            Accept Cookies
          </button>
        </div>
      </div>
    </div>
  );
};

/* ─── Navbar ─── */
const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", fn, { passive: true });
    return () => window.removeEventListener("scroll", fn);
  }, []);

  const links = [
    { label: "Features", href: "#features" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "Support", href: "#support" },
  ];

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-sm" : "bg-white/95"
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 flex items-center justify-between h-16">
        <a href="#" data-testid="nav-logo" className="flex items-center">
          <img src={LOGO_TEXT} alt="Buumped" className="h-9" />
        </a>

        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm text-gray-600 hover:text-[#F07167] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href={APK_URL}
            data-testid="nav-download-cta"
            className="text-sm font-medium text-white bg-[#F07167] px-5 py-2 rounded-full hover:bg-[#E85D52] transition-colors"
          >
            Download
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2 text-gray-600"
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-white border-t px-6 pb-4">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block py-3 text-sm text-gray-600 hover:text-[#F07167]"
            >
              {l.label}
            </a>
          ))}
          <a
            href={APK_URL}
            className="mt-2 inline-block text-sm font-medium text-white bg-[#F07167] px-5 py-2 rounded-full"
          >
            Download
          </a>
        </div>
      )}
    </nav>
  );
};

/* ─── Hero ─── */
const Hero = () => (
  <section data-testid="hero-section" className="pt-28 pb-20 sm:pt-36 sm:pb-28 bg-white">
    <div className="max-w-6xl mx-auto px-6 text-center">
      <FadeIn>
        <img src={LOGO_CIRCLE} alt="Buumped" className="w-20 h-20 mx-auto mb-8" data-testid="hero-logo" />
      </FadeIn>

      <FadeIn delay={0.1}>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight tracking-tight max-w-3xl mx-auto mb-6">
          Connect with people you cross paths with
        </h1>
      </FadeIn>

      <FadeIn delay={0.2}>
        <p className="text-lg sm:text-xl text-gray-500 max-w-2xl mx-auto mb-4 leading-relaxed">
          Have you ever seen someone, felt a spark, and then watched the moment disappear?
        </p>
        <p className="text-lg sm:text-xl text-gray-500 max-w-2xl mx-auto mb-10 leading-relaxed">
          Buumped gives you a second chance. No endless swiping. No guesswork.
          <span className="text-gray-900 font-medium"> Just real moments, rediscovered.</span>
        </p>
      </FadeIn>

      <FadeIn delay={0.3}>
        <div className="flex flex-col sm:flex-row gap-3 justify-center mb-16">
          <a
            href={APK_URL}
            data-testid="hero-download-android"
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-[#F07167] text-white font-medium rounded-full hover:bg-[#E85D52] transition-colors"
          >
            <Download size={18} />
            Download for Android
          </a>
          <a
            href="#"
            data-testid="hero-download-ios"
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-gray-100 text-gray-700 font-medium rounded-full hover:bg-gray-200 transition-colors"
          >
            <Smartphone size={18} />
            iOS Coming Soon
          </a>
        </div>
      </FadeIn>

      <FadeIn delay={0.4}>
        <div className="flex justify-center gap-12 sm:gap-16 text-center">
          {[
            { val: "50K+", label: "Downloads" },
            { val: "4.8\u2605", label: "Rating" },
            { val: "1M+", label: "Bumps Made" },
          ].map((s) => (
            <div key={s.label} data-testid={`stat-${s.label.toLowerCase().replace(/\s/g, "-")}`}>
              <div className="text-2xl sm:text-3xl font-bold text-gray-900">{s.val}</div>
              <div className="text-sm text-gray-400 mt-1">{s.label}</div>
            </div>
          ))}
        </div>
      </FadeIn>
    </div>
  </section>
);

/* ─── Feature Row ─── */
const FeatureRow = ({ icon: Icon, title, description, reversed, testId, children }) => (
  <FadeIn>
    <div
      data-testid={testId}
      className={`flex flex-col ${reversed ? "md:flex-row-reverse" : "md:flex-row"} items-center gap-12 md:gap-20 py-16 sm:py-20`}
    >
      <div className="flex-1 max-w-lg">
        <div className="w-12 h-12 bg-[#F07167]/10 rounded-xl flex items-center justify-center mb-5">
          <Icon size={24} className="text-[#F07167]" />
        </div>
        <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">{title}</h3>
        <p className="text-gray-500 text-lg leading-relaxed">{description}</p>
      </div>
      <div className="flex-1 flex justify-center">
        {children}
      </div>
    </div>
  </FadeIn>
);

const FeatureVisual = ({ items }) => (
  <div className="bg-gray-50 rounded-2xl p-6 sm:p-8 w-full max-w-sm">
    {items.map((item, i) => (
      <div key={i} className={`flex items-center gap-4 ${i > 0 ? "mt-4 pt-4 border-t border-gray-100" : ""}`}>
        <div className="w-10 h-10 bg-[#F07167]/10 rounded-lg flex items-center justify-center shrink-0">
          <item.icon size={18} className="text-[#F07167]" />
        </div>
        <div>
          <div className="text-sm font-medium text-gray-900">{item.title}</div>
          <div className="text-xs text-gray-400">{item.sub}</div>
        </div>
      </div>
    ))}
  </div>
);

/* ─── Features Section ─── */
const Features = () => (
  <section id="features" data-testid="features-section" className="bg-white">
    <div className="max-w-6xl mx-auto px-6">
      <FadeIn>
        <div className="text-center py-16 sm:py-20 border-b border-gray-100">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Built for real connections
          </h2>
          <p className="text-lg text-gray-500 max-w-xl mx-auto">
            Everything you need to turn missed moments into meaningful relationships.
          </p>
        </div>
      </FadeIn>

      <div className="divide-y divide-gray-100">
        <FeatureRow
          icon={MapPin}
          title="Proximity Detection"
          description="Discover people you've actually crossed paths with in real life. Not random strangers from the other side of town — real encounters that happened organically."
          testId="feature-proximity"
        >
          <FeatureVisual items={[
            { icon: MapPin, title: "Crossed paths at Central Park", sub: "Today, 2:30 PM" },
            { icon: MapPin, title: "Same caf\u00e9 on 5th Ave", sub: "Yesterday, 9:15 AM" },
            { icon: MapPin, title: "Morning commute \u2014 Line 6", sub: "3 times this week" },
          ]} />
        </FeatureRow>

        <FeatureRow
          icon={Lock}
          title="Private & Encrypted"
          description="End-to-end encrypted conversations, ghost mode, location blur, and full control over your visibility. Your data stays yours."
          reversed
          testId="feature-privacy"
        >
          <FeatureVisual items={[
            { icon: Shield, title: "End-to-End Encryption", sub: "All messages secured" },
            { icon: Globe, title: "Ghost Mode", sub: "Browse invisibly" },
            { icon: Lock, title: "Location Blur", sub: "Approximate areas only" },
          ]} />
        </FeatureRow>

        <FeatureRow
          icon={MessageCircle}
          title="Chat, Call & Share"
          description="Start with a message, move to voice or video when you're ready. Share photos, voice notes, and moments that matter."
          testId="feature-chat"
        >
          <FeatureVisual items={[
            { icon: MessageCircle, title: "Text & Voice Messages", sub: "Express yourself freely" },
            { icon: Video, title: "Video Calls", sub: "Face-to-face connection" },
            { icon: Image, title: "Rich Media", sub: "Photos, GIFs & more" },
          ]} />
        </FeatureRow>

        <FeatureRow
          icon={Map}
          title="Your Bump Map"
          description="See where your real-world encounters happened on an interactive map. The more you cross paths with someone, the stronger the connection signal."
          reversed
          testId="feature-map"
        >
          <div className="bg-gray-50 rounded-2xl p-6 w-full max-w-sm aspect-square flex items-center justify-center relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-[#F07167]/5 to-[#F07167]/15 rounded-2xl" />
            <div className="relative text-center">
              <Map size={48} className="text-[#F07167] mx-auto mb-4" />
              <div className="text-sm font-medium text-gray-900">12 bumps this week</div>
              <div className="text-xs text-gray-400 mt-1">3 recurring encounters</div>
            </div>
            <div className="absolute top-8 left-12 w-3 h-3 bg-[#F07167]/40 rounded-full" />
            <div className="absolute top-16 right-16 w-2 h-2 bg-[#F07167]/30 rounded-full" />
            <div className="absolute bottom-20 left-20 w-4 h-4 bg-[#F07167]/20 rounded-full" />
            <div className="absolute bottom-12 right-12 w-2.5 h-2.5 bg-[#F07167]/35 rounded-full" />
            <div className="absolute top-1/3 left-1/3 w-2 h-2 bg-[#F07167]/25 rounded-full" />
          </div>
        </FeatureRow>
      </div>
    </div>
  </section>
);

/* ─── How It Works ─── */
const HowItWorks = () => (
  <section id="how-it-works" data-testid="how-it-works-section" className="py-20 sm:py-28 bg-gray-50">
    <div className="max-w-6xl mx-auto px-6">
      <FadeIn>
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            How Buumped works
          </h2>
          <p className="text-lg text-gray-500">
            Three simple steps. Zero swiping.
          </p>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 sm:gap-12">
        {[
          { num: "1", title: "Walk Around", desc: "Go about your day. Buumped runs quietly in the background, noting the people nearby." },
          { num: "2", title: "Get Bumped", desc: "When you cross paths with someone, you both get a bump. The more you cross paths, the stronger the signal." },
          { num: "3", title: "Connect & Chat", desc: "Like someone's profile? Start a conversation. It's that simple \u2014 real encounters, real connections." },
        ].map((step, i) => (
          <FadeIn key={step.num} delay={i * 0.1}>
            <div data-testid={`step-${step.num}`} className="text-center md:text-left">
              <div className="w-10 h-10 bg-[#F07167] text-white rounded-full flex items-center justify-center font-bold text-sm mb-5 mx-auto md:mx-0">
                {step.num}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
              <p className="text-gray-500 leading-relaxed">{step.desc}</p>
            </div>
          </FadeIn>
        ))}
      </div>
    </div>
  </section>
);

/* ─── Support Section (replaces Pricing) ─── */
const Support = () => (
  <section id="support" data-testid="support-section" className="py-20 sm:py-28 bg-white">
    <div className="max-w-4xl mx-auto px-6">
      <FadeIn>
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Get in touch
          </h2>
          <p className="text-lg text-gray-500">
            Have questions? We're here to help.
          </p>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FadeIn delay={0.1}>
          <a
            href="mailto:info@buumped.com"
            data-testid="support-email"
            className="flex items-center gap-4 p-6 border border-gray-200 rounded-2xl hover:border-[#F07167]/30 hover:bg-[#F07167]/5 transition-colors group"
          >
            <div className="w-12 h-12 bg-[#F07167]/10 rounded-xl flex items-center justify-center shrink-0 group-hover:bg-[#F07167]/20 transition-colors">
              <Mail size={22} className="text-[#F07167]" />
            </div>
            <div>
              <div className="text-sm font-medium text-gray-900">Email Us</div>
              <div className="text-sm text-gray-500">info@buumped.com</div>
            </div>
          </a>
        </FadeIn>

        <FadeIn delay={0.2}>
          <a
            href="tel:02035762766"
            data-testid="support-phone"
            className="flex items-center gap-4 p-6 border border-gray-200 rounded-2xl hover:border-[#F07167]/30 hover:bg-[#F07167]/5 transition-colors group"
          >
            <div className="w-12 h-12 bg-[#F07167]/10 rounded-xl flex items-center justify-center shrink-0 group-hover:bg-[#F07167]/20 transition-colors">
              <Phone size={22} className="text-[#F07167]" />
            </div>
            <div>
              <div className="text-sm font-medium text-gray-900">Call Us</div>
              <div className="text-sm text-gray-500">020 3576 2766</div>
            </div>
          </a>
        </FadeIn>
      </div>

      <FadeIn delay={0.3}>
        <div className="mt-12 text-center">
          <p className="text-sm text-gray-400">
            Follow us on social media for updates and news
          </p>
          <div className="flex justify-center gap-4 mt-4">
            {SOCIALS.map((s) => (
              <a
                key={s.name}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`support-social-${s.name.toLowerCase()}`}
                className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center text-gray-500 hover:bg-[#F07167] hover:text-white transition-colors"
                title={s.name}
              >
                {s.icon}
              </a>
            ))}
          </div>
        </div>
      </FadeIn>
    </div>
  </section>
);

/* ─── Download CTA ─── */
const DownloadCTA = () => (
  <section data-testid="download-cta-section" className="py-20 sm:py-28 bg-[#F07167]">
    <div className="max-w-3xl mx-auto px-6 text-center">
      <FadeIn>
        <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
          Ready for your second chance?
        </h2>
        <p className="text-lg text-white/80 mb-10 max-w-xl mx-auto">
          Download Buumped and start connecting with the people you cross paths with every day.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href={APK_URL}
            data-testid="cta-download-android"
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-white text-[#F07167] font-medium rounded-full hover:bg-gray-100 transition-colors"
          >
            <Download size={18} />
            Download for Android
          </a>
          <a
            href="#"
            data-testid="cta-download-ios"
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-white/20 text-white font-medium rounded-full hover:bg-white/30 transition-colors"
          >
            <Smartphone size={18} />
            iOS Coming Soon
          </a>
        </div>
      </FadeIn>
    </div>
  </section>
);

/* ─── Footer ─── */
const Footer = () => (
  <footer data-testid="footer" className="bg-gray-900 py-16">
    <div className="max-w-6xl mx-auto px-6">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
        <div className="col-span-2 md:col-span-1">
          <img src={LOGO_CIRCLE} alt="Buumped" className="h-10 w-10 mb-4 rounded-full" />
          <p className="text-sm text-gray-400 leading-relaxed mb-4">
            Real moments, rediscovered.
          </p>
          <div className="space-y-2">
            <a href="mailto:info@buumped.com" className="flex items-center gap-2 text-xs text-gray-400 hover:text-white transition-colors" data-testid="footer-email">
              <Mail size={12} /> info@buumped.com
            </a>
            <a href="tel:02035762766" className="flex items-center gap-2 text-xs text-gray-400 hover:text-white transition-colors" data-testid="footer-phone">
              <Phone size={12} /> 020 3576 2766
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-sm font-medium text-white mb-4">Product</h4>
          <ul className="space-y-2">
            <li><a href="#features" data-testid="footer-link-features" className="text-sm text-gray-400 hover:text-white transition-colors">Features</a></li>
            <li><a href="#how-it-works" data-testid="footer-link-how-it-works" className="text-sm text-gray-400 hover:text-white transition-colors">How It Works</a></li>
            <li><a href={APK_URL} data-testid="footer-link-download" className="text-sm text-gray-400 hover:text-white transition-colors">Download</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-medium text-white mb-4">Legal</h4>
          <ul className="space-y-2">
            <li><Link to="/privacy" data-testid="footer-link-privacy" className="text-sm text-gray-400 hover:text-white transition-colors">Privacy Policy</Link></li>
            <li><Link to="/terms" data-testid="footer-link-terms" className="text-sm text-gray-400 hover:text-white transition-colors">Terms of Service</Link></li>
            <li><Link to="/cookies" data-testid="footer-link-cookies" className="text-sm text-gray-400 hover:text-white transition-colors">Cookie Policy</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-medium text-white mb-4">Support</h4>
          <ul className="space-y-2">
            <li><a href="mailto:info@buumped.com" data-testid="footer-link-help" className="text-sm text-gray-400 hover:text-white transition-colors">Help Center</a></li>
            <li><a href="mailto:info@buumped.com" data-testid="footer-link-contact" className="text-sm text-gray-400 hover:text-white transition-colors">Contact Us</a></li>
            <li><a href="#" data-testid="footer-link-status" className="text-sm text-gray-400 hover:text-white transition-colors">Status</a></li>
          </ul>
        </div>
      </div>

      {/* Social icons */}
      <div className="border-t border-gray-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-gray-500">
          &copy; {new Date().getFullYear()} Buumped. All rights reserved. Users must be 18+ to use this service.
        </p>
        <div className="flex gap-3">
          {SOCIALS.map((s) => (
            <a
              key={s.name}
              href={s.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`social-${s.name.toLowerCase()}`}
              className="w-9 h-9 bg-gray-800 rounded-full flex items-center justify-center text-gray-400 hover:bg-[#F07167] hover:text-white transition-colors"
              title={s.name}
            >
              {s.icon}
            </a>
          ))}
        </div>
      </div>
    </div>
  </footer>
);

/* ─── Main Landing Page ─── */
export default function LandingPage() {
  return (
    <div className="bg-white" data-testid="landing-page">
      <Navbar />
      <Hero />
      <Features />
      <HowItWorks />
      <Support />
      <DownloadCTA />
      <Footer />
      <CookieConsent />
    </div>
  );
}
